import axios from 'axios'
import * as utils from 'src/apis/apiUtils'

export default {
  index(params) {
    return axios.get(utils.getApiUrl('/masters/bui'), {
      params: params || {}
    })
  },
  create({ data }) {
    return axios.post(utils.getApiUrl('/masters/bui'), data)
  },
  update({ id, data }) {
    return axios.put(utils.getApiUrl(`/masters/bui/${id}`), data)
  },
}
